import { CommonModule } from "@angular/common";
import { Component, inject, input } from "@angular/core";
import { AdminService } from "@malirang/api-client";
import {
    AlertService,
    Icon,
    IconButton,
    ModalService,
} from "@malirang/front-share";
import { MaskingStore } from "libs/front-share/src/stores/masking.store";
import { AdminStore } from "../../../stores/admin.store";
import { UnmaskVerificationModal } from "./modals/unmask-verification.modal";

@Component({
    selector: "app-top-bar",
    templateUrl: "./top-bar.component.html",
    styleUrls: ["./top-bar.component.scss"],
    standalone: true,
    imports: [CommonModule, IconButton, Icon],
})
export class TopBar {
    readonly adminStore = inject(AdminStore);
    readonly alertService = inject(AlertService);
    readonly maskingStore = inject(MaskingStore);
    readonly modalService = inject(ModalService);
    readonly adminService = inject(AdminService);

    admin = this.adminStore.admin;
    header = input.required<string>();
    description = input<string>();

    logout() {
        this.alertService
            .open({
                title: "로그아웃",
                type: "warning",
                content: `로그아웃 하시겠습니까?`,
                buttons: {
                    confirm: {
                        text: "확인",
                        color: "yellow",
                    },
                },
            })
            .closed.subscribe({
                next: (res) => {
                    if (res?.action === "confirm") {
                        this.adminStore.logout();
                    }
                },
            });
    }

    toggleMasking() {
        if (!this.maskingStore.isMaskingEnabled()) {
            this.maskingStore.enable();
            return;
        }

        this.modalService.create(UnmaskVerificationModal).closed.subscribe({
            next: (res: any) => {
                if (res?.confirmed) {
                    // 마스킹 해제 로그 기록 API 호출
                    this.adminService
                        .adminControllerLogUnmask({
                            body: { reason: res.reason },
                        })
                        .subscribe({
                            next: () => {
                                this.maskingStore.disable();
                            },
                            error: () => {
                                // API 호출 실패해도 마스킹 해제는 진행
                                this.maskingStore.disable();
                            },
                        });
                }
            },
        });
    }
}
